import Vue from 'vue'
import Vuex from 'vuex';
import router from '@/router'

Vue.use(Vuex)

import store from './store'

export default class Quiz {
    constructor() {
        this.bus = new Vue()
        this.bootingCallbacks = []
    }

    /**
     * Create the Quiz Vue instance.
     */
    start() {
        this._boot()

        let _this = this

        this.app = new Vue({
            el: '#app',
            store,
            router,
            data: function () {
                return {
                    socket: false,
                    activityTimer: null,
                    activityTimeout: 45000,
                    pongTimeout: 5000,
                }
            },

            created() {
                _this.$on('ws-message', message => {
                    this.socket.send(JSON.stringify(message))
                    this.resetActivityCheck()
                })

                _this.$on('disconnect', () => {
                    this.socket.close()
                })

                _this.$on('notification-read', (notification) => {
                    this.$store.commit('auth/readNotification', {notification: notification})
                })

                _this.$on('user-loaded', () => {
                    if (get(this.$store.state, 'auth.user.id')) {
                        window.Echo.private('App.Models.User.' + this.$store.state.auth.user.id)
                            .listen('.chat.newMessage', (data) => {
                                this.$store.commit('auth/updateUnreadChats', {unreadChats: data.unreadChats})
                                _this.$emit('newChatMessage')
                            })
                            .listen('.friend.online', () => {
                                _this.$emit('friendOnline')
                            })
                            .listen('.friend.offline', () => {
                                _this.$emit('friendOnline')
                            })
                            .listen('.user.levelChanged', (data) => {
                                this.$store.commit('auth/updateUserData', {field: 'level', value: data.level})
                            })
                            .listen('.user.balanceChanged', (data) => {
                                this.$store.commit('auth/updateUserData', {field: 'balance', value: data.balance})
                            })
                            .notification((notification) => {
                                this.$store.commit('auth/insertNotification',  { notification: notification})
                                _this.$emit('new-notification', notification)
                            });

                        window.Echo.join('online.' + this.$store.state.auth.user.id);
                    }
                })
            },

            methods: {
                connect() {
                    if (get(this.socket, 'readyState', 3) < 3) {
                        return;
                    }

                    return new Promise((resolve, reject) => {
                        this.socket = new WebSocket(process.env.MIX_QUIZ_WS_SERVER + '?appKey=' + process.env.MIX_WS_APP_KEY);

                        this.socket.onopen = () => {
                            this.$store.dispatch('websocket/connected', true)
                            _this.$emit('ws-connection-open')
                            this.resetActivityCheck()

                            resolve(this.socket);
                        };

                        this.socket.onmessage = ({data}) => {
                            let decodedData = JSON.parse(data)

                            if (decodedData.event === 'pusher_internal:subscription_succeeded') {
                                this.$store.commit('websocket/subscribe', {
                                    channel: decodedData.channel,
                                    data: decodedData.data
                                })
                            }

                            if (decodedData.event === 'pusher:error' && [401, 450].includes(decodedData.data.code)) {
                                this.socket.close()
                                this.$router.push({ path: '/500', query: { code: decodedData.data.code }})
                            }

                            if (decodedData.event === 'unsubscribe_success') {
                                this.$store.commit('websocket/unsubscribe', decodedData.channel)
                            }

                            _this.$emit(decodedData.event, decodedData)
                            this.resetActivityCheck()
                        };

                        this.socket.onclose = () => {
                            _this.$emit('ws-connection-close')

                            console.log('connection closed')

                            this.$store.commit('websocket/flushChannels')
                            clearTimeout(this.activityTimer);
                            this.$store.dispatch('websocket/connected', false)
                        };

                        this.socket.onerror = (error) => {
                            _this.$emit('ws-connection-error')
                            this.$store.commit('websocket/flushChannels')
                            clearTimeout(this.activityTimer);
                            this.$store.dispatch('websocket/connected', false)
                            reject(error);
                        };
                    });
                },

                resetActivityCheck() {
                    if (this.activityTimer) {
                        clearTimeout(this.activityTimer);
                    }

                    // Send ping after inactivity
                    this.activityTimer = setTimeout(() => {
                        this.socket.send(JSON.stringify({
                            event: 'pusher:ping',
                            data: {}
                        }), {})
                        // Wait for pong response
                        this.activityTimer = setTimeout(() => {
                            this.socket.close();
                        }, (this.pongTimeout))
                    }, (this.activityTimeout))
                }
            }
        })
    }

    /**
     * Register a callback to be called before Quiz starts. This is used to bootstrap
     * addons, custom fields, or anything else
     */
    booting(callback) {
        this.bootingCallbacks.push(callback)
    }

    /**
     * Register a listener on the event bus
     */
    $on(...args) {
        this.bus.$on(...args)
    }

    /**
     * Register a one-time listener on the event bus
     */
    $once(...args) {
        this.bus.$once(...args)
    }

    /**
     * De-register a listener on the event bus
     */
    $off(...args) {
        this.bus.$off(...args)
    }

    /**
     * Emit an event on the event bus
     */
    $emit(...args) {
        this.bus.$emit(...args)
    }

    /**
     * Execute all of the booting callbacks.
     */
    _boot() {
        this.bootingCallbacks.forEach(callback => callback(Vue))

        this.bootingCallbacks = []
    }
}
